import React from 'react';
import Nav from "./Nav"


const Header = () => {
    return (
        <div className="logo_nav">
            <header>
                <h1>Animal cards</h1>
            </header>
            <Nav />
        </div>
    );
};


export default Header;

